import { Link } from '@tanstack/react-router'
import { BookOpen } from 'lucide-react'
import { HELP_FOR_ROUTE, HELP_FOR_TOPIC, type HelpRoute, type HelpTopic } from '../../lib/help/links'

/**
 * "Learn more" link to the guide for an app route or a topic (docs/help-centre.md). Owner: slice 36 `web-help-centre`.
 *
 * Pass it as `actions` on a PaneHeader or `action` on an EmptyState: `<EmptyState action={<LearnMore route="/schedule" />} />`.
 * The `help=` / `learnMore=` props TEM has on its PageHeader and EmptyState belong to `packages/ui` (slice 14
 * `web-shell`); until they exist this component is the hook.
 */
export function LearnMore({
  route,
  topic,
  anchor,
  label = 'Learn more',
}: ({ route: HelpRoute; topic?: never } | { topic: HelpTopic; route?: never }) & { anchor?: string; label?: string }) {
  const id = route ? HELP_FOR_ROUTE[route] : HELP_FOR_TOPIC[topic as HelpTopic]
  const [section, slug] = id.split('/') as [string, string]
  return (
    <Link
      to="/help/$section/$slug"
      params={{ section, slug }}
      hash={anchor}
      className="inline-flex items-center gap-1 text-sm text-primary hover:underline"
    >
      <BookOpen className="size-3.5" aria-hidden />
      {label}
    </Link>
  )
}
